export enum TimesheetAction {
  None = 0,
  Save = 1,
  Submit = 2,
  Recall = 3,
  Refresh = 4,
}
